module.exports = __webpack_public_path__ + "images/521de99bbe873237dc6347521459700f-logo_white.png";